module.exports = __webpack_public_path__ + "static/media/1014559.2be3b273.jpg";